import React from 'react';

const ACTIVE = { bg: '#E6F7F2', fg: '#01AB7D', dot: '#01AB7D', label: 'Ativo' };
const INACTIVE = { bg: '#FDECEC', fg: '#DC3545', dot: '#DC3545', label: 'Inativo' };

export const StatusPill = ({ active }) => {
  const s = active ? ACTIVE : INACTIVE;
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        padding: '3px 9px',
        borderRadius: 999,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        color: s.fg,
        background: s.bg,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: s.dot }} />
      {s.label}
    </span>
  );
};
